<template>
  <div class="analysis-order-list">
    <a-card>
      <div class="filters">
        <a-select v-model="filters.order_type" placeholder="订单类型" style="width: 140px" :allowClear="true">
          <a-select-option :value="0">全部类型</a-select-option>
          <a-select-option :value="1">消费订单</a-select-option>
          <a-select-option :value="2">服务订单</a-select-option>
        </a-select>
        <a-select v-model="filters.product_type" placeholder="商品类型" style="width: 180px" :allowClear="true">
          <a-select-option :value="0">全部商品</a-select-option>
          <a-select-option :value="1">电子真题</a-select-option>
          <a-select-option :value="2">真题笔记</a-select-option>
          <a-select-option :value="3">会员题库</a-select-option>
          <a-select-option :value="4">冲刺题库</a-select-option>
          <a-select-option :value="5">课程精讲</a-select-option>
          <a-select-option :value="6">打印资料</a-select-option>
        </a-select>
        <a-select v-model="filters.pay_status" placeholder="支付状态" style="width: 140px" :allowClear="true">
          <a-select-option value="">全部支付</a-select-option>
          <a-select-option value="1">已支付</a-select-option>
          <a-select-option value="0">未支付</a-select-option>
        </a-select>
        <a-input v-model="filters.keyword" placeholder="搜索订单号" style="width: 200px" />
        <a-button type="primary" @click="handleSearch">查询</a-button>
        <a-button @click="handleReset">重置</a-button>
      </div>

      <a-table :columns="columns" :data-source="list" :loading="tableLoading" :rowKey="'id'" bordered />
      
    </a-card>
  </div>
</template>

<script>
import { getAdminOrderList } from '@/libs/api'

export default {
  name: 'AnalysisOrderList',
  data(){
    return {
      loading: false,
      tableLoading: false,
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      filters: {
        order_type: 0,
        product_type: 0,
        pay_status: '',
        keyword: ''
      },
      columns: [
        { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
        { title: '订单号', dataIndex: 'order_no', key: 'order_no', width: 160 },
        { title: '购买用户', dataIndex: 'nickname', key: 'nickname', width: 80 },
        { title: '订单类型', key: 'order_type', width: 120, customRender: (text, row) => (row.order_type === 1 ? '消费订单' : (row.order_type === 2 ? '服务订单' : '-')) },
        { title: '支付状态', key: 'pay_status', width: 100, customRender: (text, row) => (row.pay_status === 1 ? '已支付' : (row.pay_status === 0 ? '未支付' : '-')) },
        { title: '商品类型', key: 'product_types', width: 180, customRender: (text, row) => {
          const map = {1:'电子真题',2:'真题笔记',3:'会员题库',4:'冲刺题库',5:'课程精讲',6:'打印资料'}
          const textVal = (row.product_types || []).map(t => map[t] || t).join('，')
          return textVal
        } },
        { title: '订单金额', dataIndex: 'total_amount', key: 'total_amount', width: 100 },
        { title: '支付金额', dataIndex: 'pay_amount', key: 'pay_amount', width: 100 },
        { title: '创建时间', dataIndex: 'created_at', key: 'created_at', width: 160 },
      ]
    }
  },
  mounted(){
    this.fetchList()
  },
  methods: {
    handlePageChange(p){
      this.page = p
      this.fetchList()
    },
    handleSearch(){
      this.page = 1
      this.fetchList()
    },
    handleReset(){
      this.filters = { order_type: 0, product_type: 0, pay_status: '', keyword: '' }
      this.page = 1
      this.fetchList()
    },
    async fetchList(){
      this.tableLoading = true
      try{
        const res = await getAdminOrderList({
          page: this.page,
          limit: this.limit,
          order_type: this.filters.order_type,
          product_type: this.filters.product_type,
          pay_status: this.filters.pay_status,
          keyword: this.filters.keyword
        })
        console.log('getAdminOrderList response:', res)
        this.list = (res && res.list) ? res.list : []
        this.total = (res && typeof res.total === 'number') ? res.total : 0
      }catch(e){
        console.error('getAdminOrderList error:', e)
        this.$message && this.$message.error ? this.$message.error('获取订单列表失败') : this.$Message && this.$Message.error && this.$Message.error('获取订单列表失败')
      }finally{
        this.tableLoading = false
      }
    }
  }
}
</script>

<style scoped>
.filters{ display: flex; gap: 8px; align-items: center; margin-bottom: 10px; }
</style>